// @ts-nocheck
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, IconButton, useTheme, alpha } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { useTableState } from '../../context/TableSchemaBuilderContext';
import { useTableModification } from '../../hooks/useTableModification';
import ResizeHandler from '../ResizeHandler';

// Set default and minimum heights
const DEFAULT_HEIGHT = 25;
const MIN_HEIGHT = 20;

const RowHeader = ({ index }) => {
  const theme = useTheme();
  const [showAddButton, setShowAddButton] = useState(false);

  const { schema, config } = useTableState();
  const { handleAddRow, handleRowResize } = useTableModification();
  const height = schema?.rowSettings?.[index]?.height ?? DEFAULT_HEIGHT;
  const readOnly = config?.readOnly;
  const editMode = config?.editMode;

  const handleMouseEnter = useCallback(() => {
    // Show the add button only if not in read-only mode
    if (editMode || readOnly || config?.fromConstAttributeFeature) {
      return;
    }
    setShowAddButton(true);
  }, [editMode, readOnly, config?.fromConstAttributeFeature]);

  const handleMouseLeave = useCallback(() => {
    // Show the add button only if not in read-only mode
    if (editMode || readOnly || config?.fromConstAttributeFeature) {
      return;
    }
    setShowAddButton(false);
  }, [editMode, readOnly, config?.fromConstAttributeFeature]);

  const handleAddRowClick = useCallback(() => {
    handleAddRow(index);
  }, [handleAddRow, index]);

  const handleRowResizeChange = useCallback(
    (newHeight) => {
      handleRowResize(index, newHeight);
    },
    [handleRowResize, index]
  );

  return (
    <TableCell
      sx={{
        height,
        padding: 0,
        backgroundColor: alpha(theme?.palette?.primary?.main, 0.05),
        position: 'sticky',
        left: 0,
        zIndex: 4,
        width: 50,
        minWidth: 50,
        minHeight: MIN_HEIGHT,
        borderRight: `1px solid ${alpha(theme?.palette?.primary?.main, 0.2)}`,
        borderBottom: `1px solid ${alpha(theme?.palette?.primary?.main, 0.2)}`,
        '&:hover': {
          '& .row-add-button': {
            opacity: 1,
          },
        },
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          color: theme?.palette?.text?.secondary,
          userSelect: 'none',
        }}
      >
        {index}
      </div>
      {/* Resize handler for row height */}
      {/* Only show the resize handler if not in read-only mode */}
      {!config?.readOnly && !config?.fromConstAttributeFeature && (
        <ResizeHandler
          orientation="vertical"
          onResize={handleRowResizeChange}
          initialSize={height}
          minSize={MIN_HEIGHT}
        />
      )}
      {showAddButton && (
        <IconButton
          className="row-add-button"
          size="small"
          onClick={handleAddRowClick}
          sx={{
            position: 'absolute',
            left: '20%',
            bottom: -6, // Changed from top to bottom
            transform: 'translateX(-50%)',
            width: 12,
            height: 12,
            opacity: 0,
            transition: 'opacity 0.2s',
            zIndex: 3,
            padding: '2px',
          }}
          color="primary"
        >
          <AddIcon sx={{ fontSize: '16px' }} />
        </IconButton>
      )}
    </TableCell>
  );
};

RowHeader.propTypes = {
  index: PropTypes.number.isRequired,
};

export default RowHeader;
